import {Component} from '../../core';
import constants from '../../cityConstant.js';
import {isSet,seoUrl,isEmpty} from '../../utils/common'
import {CoworkDynamicContactComponent} from './cowork-dynamic-contact.component'; 

/**
 * Coworkhome Popular spaces component
 */
export class CoworkPopularSpacesComponent extends Component {

    static alias = 'cowork-home-popular-spaces';

    constructor(el) {
        super(el);
    }

    onComponentLoaded() {

        // Initialize the popular spaces
        this.initializePopularSpaces();
    }

    initializePopularSpaces(){
        let cityId = '';
        if(globals.cityId != 1) {
            cityId = globals.cityId;
        }
        this.fetchPopularSpaces(cityId).then((popularSpaces) => {
            // Update the state
            this.setState({...this.state, popularSpaces});
            
            // Render popular spaces
            this.renderPopularSpaces(this.state.popularSpaces);

            this.initializeContactsEventPs();
        });
    }

    getEncodeFormat(response){
        return btoa(JSON.stringify(response));
    }

    fetchPopularSpaces(cityId) {
        // Render popular spaces
        return fetch(`/homes/re2/coworkPopularSpaces?cityId=${cityId}`).then((res) => res.json());
    }

    /**
     * Renders popular spaces
     * @param {Array} popular spaces 
     */
    renderPopularSpaces(popularSpaces = []) {

        this.refs.popularSpaces.innerHTML = popularSpaces.reduce((html, response) => html + `
           <div>
                <div class="cw_fs_tile">
                    <a href="${this.getUrl(response)}" >
                        <div class="cw_fs_img_wrapper">
                            ${this.getImageUrl(response)}
                        </div>
                        ${this.checkOffers(response.offers)}
                        <h3>${response.propertyName}</h3>
                        <p class="cw_fs_t_loc">${response.localityName}, ${response.cityName}</p>
                    </a>
                    <div class="cw_fs_tile_bottom clearfix">
                        <a href="${this.getUrl(response)}" >
                            ${this.getPrice(response.offers)}
                        </a>
                        <button type="button" class="cwbtn ttuc enquiryinitps" data-toggle="modal" data-target="#co_workEnquiryPopup" id="psenquiry">Enquiry</button>
                    </div>
                </div>
            </div>`, '');

        if(isEmpty(this.refs.popularSpaces.innerHTML)){
            document.getElementById("popularSpacesSection").classList.add('hide');
        }
        
        this.slickLoad();

    }

    getImageUrl(response) {
        if(response.media && response.media.length>0 ) {
            let image = response.media[0].url.replace("80x80","300x300");
            return `<img src="${image}" />`;
        } else {
            return `<img class="defualt_img" src="${window.CDNURL}/image/QC_DefaultImage.jpg" />`
        }
    }

    
    slickLoad() {
        $(".single-item-popular").slick({
                dots: false,
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                    slidesToShow: 3,
                    centerMode: false,
                    variableWidth: true,
                    slidesToScroll: 3,
                    dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                    slidesToShow: 2,
                    centerMode: false,
                    variableWidth: true,
                    slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    variableWidth: true,
                    slidesToScroll: 1
                    }
                }
                ]
            });
    }

    getPrice(response){
        let price = '';
        if(!isEmpty(response.minPrice)){
            price = `<span class="fs_t_sa">Starting at</span>
                            <h4 class="fs_t_pr">${response.minPrice}<small>/month</small></h4>`;
        }
        return price;
    }

    getUrl(response){
        let locality = (response.localityName).replace(/\s+/g, '-').toLowerCase();
        let city = (response.cityName).replace(/\s+/g, '-').toLowerCase();
        let propertyName = (response.propertyName).replace(/\s+/g, '-').toLowerCase();
        return `//www.quikr.com/coworking/listing/${propertyName}-${locality}-${city}-${response.id}`;
    }

    checkOffers(offers){
        var offer = '';
        if(!isEmpty(offers) && offers.length >0){
            offer = '<div class="offer_box mrtp10 poscale">Offers Inside</div>';
        }
        return offer;
    }

    initializeContactsEventPs() {
        var classname = document.getElementsByClassName("enquiryinitps");
        Array.from(classname).forEach((element) => {
          element.addEventListener('click', this.initializeContactFormWithPropertyId.bind(this));
        });
    }

    initializeContactFormWithPropertyId(ev) {
        // Initialize the contact form
        this.fetchContact().then((response) => {
            document.getElementById('co_workEnquiryPopup').innerHTML = response;
            let propertyId = ev.target.getAttribute("data-ref-id");
            let propertyDetail = ev.target.getAttribute("data-ref-leaddetail");
            if(document.getElementById('contactDynamicFormId')) {
                document.getElementById('contactDynamicFormId').setAttribute('data-component', 'cowork-dynamic-contact' + propertyId);
            }
            const contactComponent = new CoworkDynamicContactComponent(null, {propertyId, propertyDetail});
        });
    }

    fetchContact() {
        return fetch(`/homes/re2/coworkcontact?aj=1`).then((res) => res.text());
    }


}